$(document).ready(function(){
  $('.custom-acct-link').hover(
    function() {
      // on hover in
      $('.custom_shine').addClass('account_pop');
      $('body').addClass('account_pop');
    },
    function() {
      // on hover out
      $('.custom_shine').removeClass('account_pop');
      $('body').removeClass('account_pop');
    }
  );
});

$(document).ready(function () {
  // Disable browser's default auto-scroll on hash load
  if (window.location.hash) {
    // Scroll top immediately to stop jump
    $(window).scrollTop(0);
  }

  function showTab(attr) {
    $(".account-left h5").removeClass("active");
    $('.account-left h5[data-attr="' + attr + '"]').addClass("active");

    $(".account-right .account-box").hide();
    $(".account-right .account-box").each(function () {
      if ($(this).find('[data-attr="' + attr + '"]').length > 0) {
        $(this).fadeIn(200);
      }
    });
  }

  $(".account-left h5").on("click", function (e) {
    // Skip for logout
    if ($(this).closest("a").length > 0) return true;

    e.preventDefault();

    var attr = $(this).attr("data-attr");
    var tabId = $(this).attr("id");

    showTab(attr);

    // Save current scroll position
    var scrollPos = $(window).scrollTop();

    // Update hash safely
    if (tabId) history.replaceState(null, null, "#" + tabId);

    // Slight adjust
    $(window).scrollTop(scrollPos - 50);
  });

  // On page load
  var hash = window.location.hash.replace("#", "");
  if (hash) {
    var attr = $("#" + hash).attr("data-attr");
    if (attr) {
      showTab(attr);
    } else {
      var firstAttr = $(".account-left h5").first().attr("data-attr");
      var firstId = $(".account-left h5").first().attr("id");
      showTab(firstAttr);
      if (firstId) history.replaceState(null, null, "#" + firstId);
    }
  } else {
    var firstAttr = $(".account-left h5").first().attr("data-attr");
    var firstId = $(".account-left h5").first().attr("id");
    showTab(firstAttr);
    if (firstId) history.replaceState(null, null, "#" + firstId);
  }

  // Re-adjust scroll after all scripts load (to keep header spacing)
  setTimeout(function () {
    $(window).scrollTop(0);
  }, 200);
});


// $(document).ready(function () {
//   function showTab(attr) {
//     $(".account-left h5").removeClass("active");
//     $('.account-left h5[data-attr="' + attr + '"]').addClass("active");

//     $(".account-right .account-box").hide();
//     $(".account-right .account-box").each(function () {
//       if ($(this).find('[data-attr="' + attr + '"]').length > 0) {
//         $(this).fadeIn(200); // smooth fade
//       }
//     });
//   }

//   $(".account-left h5").on("click", function (e) {
//     // agar ye logout link ke andar ka h5 hai to kuch mat karo
//     if ($(this).closest("a").length > 0) {
//       return true; // normal redirect hone do
//     }

//     e.preventDefault();

//     var attr = $(this).attr("data-attr");
//     var tabId = $(this).attr("id");

//     showTab(attr);

//     // current scroll position store
//     var scrollPos = $(window).scrollTop();

//     // agar ID hai tabhi hash update karo
//     if (tabId) {
//       history.replaceState(null, null, "#" + tabId);
//     }

//     // scroll adjust (thoda neeche)
//     $(window).scrollTop(scrollPos - 50);
//   });

//   // On page load
//   var hash = window.location.hash.replace("#", "");
//   if (hash) {
//     var attr = $("#" + hash).attr("data-attr");
//     if (attr) {
//       showTab(attr);
//     } else {
//       var firstAttr = $(".account-left h5").first().attr("data-attr");
//       var firstId = $(".account-left h5").first().attr("id");
//       showTab(firstAttr);
//       if (firstId) history.replaceState(null, null, "#" + firstId);
//     }
//   } else {
//     var firstAttr = $(".account-left h5").first().attr("data-attr");
//     var firstId = $(".account-left h5").first().attr("id");
//     showTab(firstAttr);
//     if (firstId) history.replaceState(null, null, "#" + firstId);
//   }
// });






